export default {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'ncef-5d9de.firebaseapp.com',
  databaseURL: 'https://ncef-5d9de.firebaseio.com',
  projectId: 'ncef-5d9de',
  storageBucket: 'ncef-5d9de.appspot.com',
  messagingSenderId: '120521429786',
  appId: '1:120521429786:web:3edbced8c571fbea2452a3',
  measurementId: 'G-JSYHWEDFDL',
};
